export default {
  reviewHelp: 'w-18 h-18',
  reviewItemDivOne: 'product-double-quote',
  reviewItemDivTwo: 'flex pb-6 md:pb-10',
  reviewItemDivThree: 'w-full md:w-8/12',
  readReviewMainDiv: 'block md:flex mb-50 md:mb-30',
  reviewIconRite: 'icon-arrow-right-o text-12',
  reviewCloseBtn: 'absolute write-review-modal-close ',
  reviewCloseSpan: 'closespan',
  reviewDialogueContent:
    'font-sans-roma text-base text-black-lighter py-3 text-center',
  reviewDialogueTitle:
    'absolute pt-0 pl-0 pb-6 text-4xl font-sans-light text-black-lighter write-review-close text-40',
  backDropStyles:
    'fixed inset-0 sm:py-20 mdp:py-30 md:py-30 bg-alpha-black-70 z-51 overflow-hidden war-modal z-20',
  logOutDialogue:
    'logout-dialog mx-auto text-left md:border-0 modal-middle md:w-630 bg-white sm:w-11/12 overflow-auto h-full relative',
  readreviewintro: {
    wrapper: 'w-full md:w-8/12',
    heading:
      'text-36 leading-48 text-black font-BornreadyRegular tracking-normal font-normal',
    description: 'font-sans-roma text-s13-m13-l15 leading-normal mb-3 md:mb-10',
    ratingbar: 'font-sans-roma text-grey-darkest text-13 mb-30 inline-flex',
    reviewCount: 'ml-10 relative cursor-pointer',
    ratingCount: 'ml-20 relative cursor-pointer',
    link: 'cursor-default',
    ratingLink: 'cursor-pointer',
  },
  reviewfilter: {
    wrapper: 'w-full md:w-4/12 leading-none mt-40 md:mt-0',
    filterFlex: 'text-center md:text-right',
    wrapperWidth: 'md:w-6/9 md:inline-flex',
    sortlabeltext:
      'font-sans-roma font-bold md:mr-20 float-left w-1/6 md:w-auto text-13 mt-1',
    showlabeltext:
      'font-sans-roma font-bold md:mr-20 float-left w-1/6 md:w-auto text-13 mt-1',
    writereviewlink:
      'py-12 px-20 text-center border-2 border-black border-solid',
    RatingSort: 'mt-15 overflow-hidden md:mt-0',
    RatingShow: 'mt-15 overflow-hidden md:mt-0',
    RatingSortlabel: 'float-left mr-15 font-sans-roma w-2/6 md:w-auto',
    RatingShowlabel: 'float-left mr-15 font-sans-roma w-2/6 md:w-auto',
    RatingSortSelectbox: 'review-select pt-0 pb-0 pl-2 pr-2 text-base',
    writeReviewLinkText: '',
    writeReviewLinkSpan:
      'text-black font-BebasNeueRegular text-16 md:text-13 leading-16',
    ratingFilterWrap: 'md:inline-flex',
  },
  reviewitem: {
    wrapperMargin: '',
    wrapper: 'mb-60 md:mb-37 relative',
    leftWrapperDiv: '',
    rightWrapperDiv: 'md:w-2/3 sm:mt-25 md:mt-0',
    usernickname:
      'font-HelveticaNeueMedium text-grey leading-19 text-16 tracking-normal',
    userLocationContainer: 'text-13',
    yourlocation: 'my-15 text-13 md:mt-10',
    userlocation: 'font-sans-bold ml-1 ',
    reviewtitle:
      'font-HelveticaNeueMedium text-black leading-16 text-18 tracking-normal pb-30 pt-20 md:pt-15 md:pb-20',
    ratingWrapper: 'md:flex justify-between',
    reviewtext:
      'text-18 md:text-16 leading-28 text-black font-HelveticaNeueLight tracking-normal mb-20',
    usefultext: '',
    rating_review: '',
    ratingLink: 'cursor-default',
    ratingWidth: 'w-auto inline text-base',
    ratingTime:
      'w-full md:w-4/12 text-right mr-0 text-xs md:text-base leading-14 md:leading-17 text-grey tracking-normal font-HelveticaNeueLight',
    submitFeedback: 'submit-feedback ml-25',
    thumbsUp: 'thumbs-up mr-5',
    thumbsDown: 'thumbs-down mr-5',
    thumbsUpimg: 'thumbs-up-img w-18',
    thumbsDownimg: 'thumbs-down-img w-18',
    thumbCount: 'absolute',
  },
  loadmorereviews: {
    wrapper: 'w-full text-center',
    buyNowButton:
      'font-BebasNeueRegular text-18 leading-30 tracking-wider text-center gradient-line ',
  },
  reviewhelpful: 'relative float-right',
};
